import {FC, useMemo, useState} from 'react';
import {Box} from '@mui/material';
import {UpdateAttendeesFromContactListStyle} from './UpdateAttendeesFromContactList.styles';
import {CONTACT_LIST_STEP} from '../../Profile/ContactList/ContactListTable/ImportContactList';
import {ValidateAttendeeDataTable} from './ValidateAttendeeDataTable';
import {SelectColumn} from './SelectColumn';
import {
	UploadAttendeeFromContactsContext,
	UploadAttendeeFromContactsContextType,
} from './UploadAttendeeFromContactsContext';

export interface IUpdateAttendeesFromContactList {
	onCloseModal: () => void;
}

export const UpdateAttendeesFromContactList: FC<IUpdateAttendeesFromContactList> = ({onCloseModal}) => {
	const [searchColumn, setSearchColumn] = useState('');

	const [activeStep, setActiveStep] = useState(CONTACT_LIST_STEP.MATCH_COLUMNS);

	const formData = useMemo(() => {
		switch (activeStep) {
			case CONTACT_LIST_STEP.UPLOADED_FILE:
				return <SelectColumn navigate={setActiveStep} />;

			case CONTACT_LIST_STEP.VALIDATE_DATA:
				return <ValidateAttendeeDataTable onClose={onCloseModal} />;

			default:
				return <SelectColumn navigate={setActiveStep} />;
		}
	}, [activeStep]);

	const uploadFromComtactsValue: UploadAttendeeFromContactsContextType = useMemo(
		() => ({searchColumn, setSearchColumn}),
		[searchColumn]
	);

	return (
		<UploadAttendeeFromContactsContext.Provider value={uploadFromComtactsValue}>
			<Box sx={UpdateAttendeesFromContactListStyle.wrapper}>{formData}</Box>
		</UploadAttendeeFromContactsContext.Provider>
	);
};
